"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutFailure = exports.logoutSuccess = exports.logoutRequest = exports.loginFailure = exports.loginSuccess = exports.loginRequest = exports.getCodeFailure = exports.getCodeSuccess = exports.getCodeRequest = exports.fetchUserDenied = exports.fetchUserFailure = exports.fetchUserSuccess = exports.fetchUserRequest = exports.LOGOUT_FAILURE = exports.LOGOUT_SUCCESS = exports.LOGOUT_REQUEST = exports.LOGIN_FAILURE = exports.LOGIN_SUCCESS = exports.LOGIN_REQUEST = exports.GET_CODE_FAILURE = exports.GET_CODE_SUCCESS = exports.GET_CODE_REQUEST = exports.FETCH_USER_DENIED = exports.FETCH_USER_FAILURE = exports.FETCH_USER_SUCCESS = exports.FETCH_USER_REQUEST = void 0;
exports.FETCH_USER_REQUEST = 'user/FETCH_USER_REQUEST';
exports.FETCH_USER_SUCCESS = 'user/FETCH_USER_SUCCESS';
exports.FETCH_USER_FAILURE = 'user/FETCH_USER_FAILURE';
exports.FETCH_USER_DENIED = 'user/FETCH_USER_DENIED';
exports.GET_CODE_REQUEST = 'user/GET_CODE_REQUEST';
exports.GET_CODE_SUCCESS = 'user/GET_CODE_SUCCESS';
exports.GET_CODE_FAILURE = 'user/GET_CODE_FAILURE';
exports.LOGIN_REQUEST = 'user/LOGIN_REQUEST';
exports.LOGIN_SUCCESS = 'user/LOGIN_SUCCESS';
exports.LOGIN_FAILURE = 'user/LOGIN_FAILURE';
exports.LOGOUT_REQUEST = 'user/LOGOUT_REQUEST';
exports.LOGOUT_SUCCESS = 'user/LOGOUT_SUCCESS';
exports.LOGOUT_FAILURE = 'user/LOGOUT_FAILURE';
var fetchUserRequest = function () { return ({ type: exports.FETCH_USER_REQUEST }); };
exports.fetchUserRequest = fetchUserRequest;
var fetchUserSuccess = function (data) { return ({ type: exports.FETCH_USER_SUCCESS, data: data }); };
exports.fetchUserSuccess = fetchUserSuccess;
var fetchUserFailure = function (e) { return ({ type: exports.FETCH_USER_FAILURE, e: e }); };
exports.fetchUserFailure = fetchUserFailure;
var fetchUserDenied = function () { return ({ type: exports.FETCH_USER_DENIED }); };
exports.fetchUserDenied = fetchUserDenied;
var getCodeRequest = function () { return ({ type: exports.GET_CODE_REQUEST }); };
exports.getCodeRequest = getCodeRequest;
var getCodeSuccess = function () { return ({ type: exports.GET_CODE_SUCCESS }); };
exports.getCodeSuccess = getCodeSuccess;
var getCodeFailure = function (e) { return ({ type: exports.GET_CODE_FAILURE, e: e }); };
exports.getCodeFailure = getCodeFailure;
var loginRequest = function () { return ({ type: exports.LOGIN_REQUEST }); };
exports.loginRequest = loginRequest;
var loginSuccess = function (client, token) { return ({ type: exports.LOGIN_SUCCESS, client: client, token: token }); };
exports.loginSuccess = loginSuccess;
var loginFailure = function (e) { return ({ type: exports.LOGIN_FAILURE, e: e }); };
exports.loginFailure = loginFailure;
var logoutRequest = function () { return ({ type: exports.LOGOUT_REQUEST }); };
exports.logoutRequest = logoutRequest;
var logoutSuccess = function () { return ({ type: exports.LOGOUT_SUCCESS }); };
exports.logoutSuccess = logoutSuccess;
var logoutFailure = function (e) { return ({ type: exports.LOGOUT_FAILURE, e: e }); };
exports.logoutFailure = logoutFailure;
